export default {
  methods: {
    rnAppMetricaReportEvent(eventName, eventPayload = {}) {
      window.RnAppMetricaReportEvent && window.RnAppMetricaReportEvent(eventName, eventPayload);
    },
  },
};
